import { DefaultTheme } from 'styled-components';

type GetBorderLinearGradient = (theme: DefaultTheme) => string;

export const getBorderLinearGradient: GetBorderLinearGradient = (theme) => `
  position: relative;
  background: white;
  border: none;

  &:before {
    content: '';
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: -1;
    margin: -3px;
    border-radius: 0.45rem;
    background: ${theme.palette.brand.linear_gradient ?? 'transparent'};
  }
`;
